import ReportContentLayout from "./ReportContentLayout";
import keyHighlightsIcon from "../../assets/images/KeyHighlights.png";

const AboutReport = ({ report }) => {
  return (
    <ReportContentLayout title="Market Overview">
      <div className="mb-4">
        {report?.Description ? (
          <div
            className="dynamic-content"
            dangerouslySetInnerHTML={{
              __html: report.Description.replace(
                /line-height:\s*[\d.]+(px|in|cm|mm|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%);?/gi,
                "line-height: 1.6 !important;",
              )
                .replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, "$1")
                .replace(/<u\b[^>]*>([\s\S]*?)<\/u>/gi, "$1")
                .replace(/text-decoration(-line)?:\s*underline;?/gi, ""),
            }}
          />
        ) : (
          <>
            <p className="mb-3">
              The Global Waste To Energy (WTE) Market will grow from USD 41.6
              Billion in 2025 to USD 64.2 Billion by 2031 at a 9.07% CAGR. The
              Waste to Energy (WTE) market refers to technologies and facilities
              that convert municipal solid waste and industrial waste into
              usable energy, such as electricity, heat, or fuel. Instead of
              waste going to landfills, WTE processes like incineration,
              gasification, pyrolysis, and biomass digestion help generate
              energy while reducing overall waste volume.
            </p>
            <p className="mb-0">
              Increasing global pressure to reduce landfill usage and carbon
              emissions is fueling rapid investment in WTE projects as
              governments and industries seek environmentally responsible energy
              alternatives. The Delhi government informed the NGT that by
              December 2028 the city will be able to process 7,750 TPD more
              municipal solid waste through the expansion of four WTE plants and
              the addition of two new biogas facilities.
            </p>
          </>
        )}
      </div>

      {report?.MarketDynamics?.highlights &&
        report.MarketDynamics.highlights.length > 0 && (
          <div
            className="p-4 rounded-3"
            style={{ backgroundColor: "#F8FAFC", border: "1px solid #EFF6FF" }}
          >
            <div className="d-flex align-items-center gap-2 mb-3">
              <img
                src={keyHighlightsIcon}
                alt="Key Highlights"
                style={{ width: "24px", height: "24px", objectFit: "contain" }}
              />
              <h5
                className="fw-bold mb-0 text-dark"
                style={{ fontSize: "1rem" }}
              >
                Key Highlights
              </h5>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <ul className="list-unstyled d-flex flex-column gap-1 mb-0">
                  {report.MarketDynamics.highlights
                    .filter((_, index) => index % 2 === 0)
                    .map((item, index) => (
                      <li
                        key={index}
                        className="d-flex align-items-start gap-2"
                      >
                        {/* <IoCheckmarkCircleOutline className="flex-shrink-0" size={20} style={{ color: '#053b84', marginTop: '1px' }} /> */}
                        <span
                          className="flex-shrink-0 text-dark fw-bold"
                          style={{ fontSize: "18px", marginTop: "-4px" }}
                        >
                          •
                        </span>
                        <span
                          className="text-secondary"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {item}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled d-flex flex-column gap-1 mb-0">
                  {report.MarketDynamics.highlights
                    .filter((_, index) => index % 2 !== 0)
                    .map((item, index) => (
                      <li
                        key={index}
                        className="d-flex align-items-start gap-2"
                      >
                        {/* <IoCheckmarkCircleOutline className="flex-shrink-0" size={20} style={{ color: '#053b84', marginTop: '1px' }} /> */}
                        <span
                          className="flex-shrink-0 text-dark fw-bold"
                          style={{ fontSize: "18px", marginTop: "-4px" }}
                        >
                          •
                        </span>
                        <span
                          className="text-secondary"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {item}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        )}
    </ReportContentLayout>
  );
};

export default AboutReport;
